import { Trans } from '@lingui/react/macro';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useOktaAuth } from '@okta/okta-react';
import { useAtomValue } from 'jotai';
import { Redirect } from 'react-router-dom';

import {
  practiceImageIdAtom,
  practicePatientIdAtom,
} from '../../atoms/externalAtoms';
import routesConstants from '../../routes/routes.constants';
import { colors } from '../../utils/theme';

import { FormSection } from './formSection/FormSection';

const useStyles = makeStyles(() => ({
  container: {
    // TODO: Fix the appheader issue causing it to not display properly on this page, we can then remove this margin
    margin: '-60px',
    flexWrap: 'nowrap',
  },
  splash: {
    height: 'max-content',
    background: 'no-repeat url(/assets/landingPage/toothBackground.png)',
    backgroundPosition: 'right bottom',
    backgroundColor: colors.PRIMARY,
    display: 'flex',
    flexDirection: 'column',
    padding: '60px 42px 143px',
    width: '100%',
  },
  xray: {
    margin: '67px auto 75px',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
  },
  featureContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  feature: {
    width: '250px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '&:not(:last-of-type)': {
      marginRight: '20px',
    },
  },
  icon: {
    marginBottom: '16px',
  },
  titleText: {
    textTransform: 'uppercase',
    color: colors.WHITE,
    fontFamily: 'proxima-nova, sans-serif',
  },
  text: {
    color: colors.WHITE,
    fontFamily: 'proxima-nova, sans-serif',
    textAlign: 'center',
  },
}));

export const LandingPage = () => {
  const classes = useStyles();
  const { authState } = useOktaAuth();

  const practicePatientId = useAtomValue(practicePatientIdAtom);
  const practiceImageId = useAtomValue(practiceImageIdAtom);
  if (!practicePatientId || !practiceImageId) {
    return <Redirect to={routesConstants.LOGIN} />;
  }
  if (authState && authState.isAuthenticated) {
    return <Redirect to={routesConstants.UPLOADER} />;
  }

  return (
    <Grid container className={classes.container}>
      <div className={classes.splash}>
        <Typography variant="h5" className={`${classes.titleText}`}>
          <Trans>Free with your Dentrix Detect AI Subscription</Trans>
        </Typography>
        <Typography variant="h3" className={`${classes.titleText}`}>
          <Trans>Unlock access to more chairside AI insights and tools</Trans>
        </Typography>
        <img
          src="/assets/images/landingPage/xray.png"
          alt=""
          className={classes.xray}
        />

        <div className={classes.featureContainer}>
          <div className={classes.feature}>
            <img
              src="/assets/icons/landingPage/flexibility.svg"
              alt=""
              className={classes.icon}
            />

            <Typography variant="h5" className={classes.text}>
              <Trans>More flexibility</Trans>
            </Typography>
            <Typography variant="h6" className={classes.text}>
              <Trans>Easily approve or reject individual AI annotations</Trans>
            </Typography>
          </div>
          <div className={classes.feature}>
            <img
              src="/assets/icons/landingPage/tooth.svg"
              alt=""
              className={classes.icon}
            />

            <Typography variant="h5" className={classes.text}>
              <Trans>Advanced customization</Trans>
            </Typography>
            <Typography variant="h6" className={classes.text}>
              <Trans>
                Filter caries detections by size, easily modify images
              </Trans>
            </Typography>
          </div>
          <div className={classes.feature}>
            <img
              src="/assets/icons/landingPage/settings.svg"
              alt=""
              className={classes.icon}
            />

            <Typography variant="h5" className={classes.text}>
              <Trans>Coming soon</Trans>
            </Typography>
            <Typography variant="h6" className={classes.text}>
              <Trans>View ROI from AI insights provided by VideaHealth</Trans>
            </Typography>
          </div>
        </div>
      </div>
      <FormSection />
    </Grid>
  );
};
